import React from 'react';

import NotificationView from './NotificationView';

import { useMessageData, useNotification } from './hooks';

import { setDismissNotificationMessage } from './helpers';

import { INotification } from './interfaces';
import { StorageTypes } from '../../interfaces/storage';

const Notification = ({
  ref,
  id,
  title = '',
  message,
  type,
  withReloadButton = false,
  withDismissButton = true,
  storageType = StorageTypes.Local,
}: INotification) => {
  const { hideNotification } = useNotification();
  const { icon, color, background, isTheme = false } = useMessageData(type);

  const reloadPage = () => {
    window.location.reload();
  };

  const handleDismiss = () => {
    setDismissNotificationMessage(message, storageType);
    handleClickClose();
  };

  const handleClickClose = () => hideNotification(id);

  return (
    <NotificationView
      ref={ref}
      title={title}
      message={message}
      color={color}
      isTheme={isTheme}
      background={background}
      icon={icon}
      reloadPage={reloadPage}
      onDismiss={handleDismiss}
      withReloadButton={withReloadButton}
      withDismissButton={withDismissButton}
      onClickClose={handleClickClose}
    />
  );
};

export default Notification;
